"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowTemplate = exports.onWebformNoResponseTemplate = exports.onWebformResponseTemplate = exports.ON_WEBFORM_REPLY_STATIC_VARIABLES = exports.onSmsNoResponseTemplate = exports.onSmsResponseTemplate = exports.emptyTemplate = exports.expressionTemplate = exports.timeTemplate = exports.startTemplate = exports.sendWebformTemplate = exports.sendSmsTemplate = exports.sendEmailTemplate = exports.defaultExpression = exports.createDefaultVariables = void 0;
/* eslint-disable max-params */
/* eslint-disable max-lines */
const expression_helper_1 = require("@whispir/expression-helper");
const workflow_factory_1 = require("@whispir/workflow-factory");
const workflow_definition_1 = require("@whispir/workflow-definition");
const webToSms_1 = require("./static/prebuiltTemplates/webToSms");
const callCenter_1 = require("./static/prebuiltTemplates/callCenter");
const staffFeedback_1 = require("./static/prebuiltTemplates/staffFeedback");
const workLocation_1 = require("./static/prebuiltTemplates/workLocation");
const blankFormTrigger_1 = require("./static/prebuiltTemplates/blankFormTrigger");
const blankManualTrigger_1 = require("./static/prebuiltTemplates/blankManualTrigger");
const leaveRequest_1 = require("./static/prebuiltTemplates/leaveRequest");
const eventReceived_1 = require("./static/prebuiltTemplates/eventReceived");
const employeeMotivation_1 = require("./static/prebuiltSurveys/employeeMotivation");
const employeeSatisfaction_1 = require("./static/prebuiltSurveys/employeeSatisfaction");
const newHireOnboarding_1 = require("./static/prebuiltSurveys/newHireOnboarding");
const pmfSurvey_1 = require("./static/prebuiltSurveys/pmfSurvey");
const { messageFactory: { generateSmsMessage, generateEmailMessage }, contentFactory: { generateRawContent, generateComponentContent }, dataFactory: { generateSendSmsData, generateSendWebformData }, } = workflow_factory_1.sendMessageFactory;
const { DATE, NUMBER, STRING } = expression_helper_1.variableIds;
const { SEND_WEBFORM, SEND_EMAIL, SEND_SMS, EXPRESSION, TIME, ON_SMS_REPLY, ON_SMS_NO_REPLY, ON_WEBFORM_REPLY, ON_WEBFORM_NO_REPLY, } = workflow_factory_1.ACTION_TYPES;
const { TASK, CONDITION } = workflow_factory_1.STEP_TYPES;
// TODO: create generator method for onResponse and onNoResponseStep in workflow-factory
const { generateSendSmsTaskStep, generateSendEmailTaskStep, generateSendWebformTaskStep, } = workflow_factory_1.stepFactory;
const { generateExpression } = expression_helper_1.expressionGenerators;
const { generateVariable } = expression_helper_1.variableGenerators;
const createDefaultVariables = () => ({
    input: [],
    output: [],
});
exports.createDefaultVariables = createDefaultVariables;
const defaultExpression = () => generateExpression({
    left: generateVariable({
        stepId: '0',
        variableId: null,
    }),
    right: null,
    operator: null,
    operands: null,
});
exports.defaultExpression = defaultExpression;
const generateUniqueName = (nodeType, nodeAction, namePrefix, definition) => {
    let count = 0;
    (0, workflow_definition_1.callbackStepsViaDefinitionRecursionDFS)({
        step: (0, workflow_definition_1.getRootStep)(definition),
        definition,
        stepCallback: ({ type, action }) => {
            if (type === nodeType && action === nodeAction) {
                count += 1;
            }
        },
    });
    return `${namePrefix} ${count + 1}`;
};
const sendEmailTemplate = (id, workspaceId, definition) => {
    const stepName = generateUniqueName(TASK, SEND_EMAIL, 'Email Message', definition);
    return [
        generateSendEmailTaskStep({
            id,
            variables: (0, exports.createDefaultVariables)(),
            data: generateSendSmsData({
                stepName,
                workspaceId,
                recipients: [],
                message: generateEmailMessage({
                    content: generateComponentContent({
                        subject: '',
                        components: [],
                    }),
                }),
                link: null,
                collectResponses: false,
            }),
            next: null,
        }),
    ];
};
exports.sendEmailTemplate = sendEmailTemplate;
const sendSmsTemplate = (id, workspaceId, definition) => {
    const stepName = generateUniqueName(TASK, SEND_SMS, 'SMS Message', definition);
    return [
        generateSendSmsTaskStep({
            id,
            variables: (0, exports.createDefaultVariables)(),
            data: generateSendSmsData({
                stepName,
                workspaceId,
                recipients: [],
                message: generateSmsMessage({
                    content: generateRawContent({
                        // this needs to be wrapped inside a <p> tag for replaceMessageVariables
                        // in workflow engine to work
                        subject: `<p>${stepName}</p>`,
                        body: '',
                    }),
                }),
                link: null,
                collectResponses: false,
            }),
            next: null,
        }),
    ];
};
exports.sendSmsTemplate = sendSmsTemplate;
const sendWebformTemplate = (id, workspaceId, definition) => {
    const stepName = generateUniqueName(TASK, SEND_WEBFORM, 'Web Form', definition);
    return [
        generateSendWebformTaskStep({
            id,
            variables: (0, exports.createDefaultVariables)(),
            data: generateSendWebformData({
                stepName,
                workspaceId,
                recipients: [],
                message: {
                    content: null,
                },
                link: {
                    type: 'webform',
                    content: generateComponentContent({
                        subject: '',
                        components: [],
                    }),
                },
            }),
            next: null,
        }),
    ];
};
exports.sendWebformTemplate = sendWebformTemplate;
const startTemplate = (name, workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    switch (name) {
        case 'web-to-sms':
            return (0, webToSms_1.prebuiltWebToSms)(workspaceId, request);
        case 'call-centre':
            return (0, callCenter_1.prebuiltCallCenter)(workspaceId, request);
        case 'staff-feedback':
            return (0, staffFeedback_1.prebuiltStaffFeedback)(workspaceId, request);
        case 'work-location':
            return (0, workLocation_1.prebuiltWorkLocation)(workspaceId, request);
        case 'employee-satisfaction-feedback':
            return (0, employeeSatisfaction_1.prebuiltEmployeeSatisfaction)(workspaceId, request);
        case 'new-hire-onboarding-survey':
            return (0, newHireOnboarding_1.prebuiltNewHireOnboarding)(workspaceId, request);
        case 'employee-motivation-survey':
            return (0, employeeMotivation_1.prebuiltEmployeeMotivation)(workspaceId, request);
        case 'pmf-survey':
            return (0, pmfSurvey_1.prebuiltPmfSurvey)(workspaceId, request);
        case 'leave-request':
            return (0, leaveRequest_1.leaveRequestTemplate)(workspaceId, request);
        case 'event-confirmation':
            return (0, eventReceived_1.eventReceivedTemplate)(workspaceId, request);
        case 'manual-trigger':
            return (0, blankManualTrigger_1.blankManualTriggerTemplate)(workspaceId, request);
        default:
            return (0, blankFormTrigger_1.blankFormTriggerTemplate)(workspaceId, request);
    }
});
exports.startTemplate = startTemplate;
const timeTemplate = (id) => [
    {
        id,
        version: '1.0.1',
        type: CONDITION,
        action: TIME,
        isDirty: false,
        variables: (0, exports.createDefaultVariables)(),
        data: {
            stepName: 'Wait',
            delay: {
                days: 0,
                hours: 0,
                minutes: 0,
            },
        },
        next: null,
    },
];
exports.timeTemplate = timeTemplate;
const expressionTemplate = (id) => [
    {
        id,
        version: '1.0.1',
        type: CONDITION,
        action: EXPRESSION,
        isDirty: false,
        variables: (0, exports.createDefaultVariables)(),
        data: {
            stepName: 'IF Condition',
            expression: (0, exports.defaultExpression)(),
        },
        next: null,
    },
];
exports.expressionTemplate = expressionTemplate;
const emptyTemplate = (id) => [
    {
        id,
        data: {},
        type: 'empty',
        next: null,
    },
];
exports.emptyTemplate = emptyTemplate;
const onSmsResponseTemplate = (id, parentNode, duration) => [
    {
        id,
        version: '1.0.1',
        type: CONDITION,
        action: ON_SMS_REPLY,
        variables: {
            input: [],
            output: [
                {
                    type: 'Text',
                    variableId: `${id}-internal-response-body`,
                    variableName: 'Response: Message Body',
                    variableType: STRING,
                },
                {
                    type: 'Date',
                    variableId: `${id}-internal-response-timestamp`,
                    variableName: 'Response: Time Received',
                    variableType: DATE,
                },
            ],
        },
        data: {
            stepName: `Replies For: ${parentNode.data.stepName}`,
            messageId: {
                variableId: `${parentNode.id}-internal-message-id`,
                stepId: parentNode.id,
                valueType: NUMBER,
            },
            collectResponses: { duration },
        },
        next: null,
    },
];
exports.onSmsResponseTemplate = onSmsResponseTemplate;
const onSmsNoResponseTemplate = (id, parentNode, duration) => [
    {
        id,
        version: '1.0.1',
        type: CONDITION,
        action: ON_SMS_NO_REPLY,
        variables: {
            input: [],
            output: [],
        },
        data: {
            stepName: `No Replies For: ${parentNode.data.stepName}`,
            messageId: {
                variableId: `${parentNode.id}-internal-message-id`,
                stepId: parentNode.id,
                valueType: NUMBER,
            },
            collectResponses: { duration },
        },
        next: null,
    },
];
exports.onSmsNoResponseTemplate = onSmsNoResponseTemplate;
const ON_WEBFORM_REPLY_STATIC_VARIABLES = (stepId) => [
    {
        type: 'Date',
        variableId: `${stepId}-internal-response-timestamp`,
        variableName: 'Response: Time Received',
        variableType: 'date',
    },
];
exports.ON_WEBFORM_REPLY_STATIC_VARIABLES = ON_WEBFORM_REPLY_STATIC_VARIABLES;
const onWebformResponseTemplate = (id, parentNode, duration) => [
    {
        id,
        version: '1.0.1',
        type: CONDITION,
        action: ON_WEBFORM_REPLY,
        variables: {
            input: [],
            output: [...(0, exports.ON_WEBFORM_REPLY_STATIC_VARIABLES)(id)],
        },
        data: {
            stepName: `Replies For: ${parentNode.data.stepName}`,
            token: {
                variableId: `${parentNode.id}-internal-token`,
                stepId: parentNode.id,
                valueType: STRING,
            },
            collectResponses: { duration },
        },
        next: null,
    },
];
exports.onWebformResponseTemplate = onWebformResponseTemplate;
const onWebformNoResponseTemplate = (id, parentNode, duration) => [
    {
        id,
        version: '1.0.1',
        type: CONDITION,
        action: ON_WEBFORM_NO_REPLY,
        variables: {
            input: [],
            output: [],
        },
        data: {
            stepName: `No Replies For: ${parentNode.data.stepName}`,
            token: {
                variableId: `${parentNode.id}-internal-token`,
                stepId: parentNode.id,
                valueType: STRING,
            },
            collectResponses: { duration },
        },
        next: null,
    },
];
exports.onWebformNoResponseTemplate = onWebformNoResponseTemplate;
exports.workflowTemplate = {
    creatorUserId: 0,
    creatorUserName: '',
    definition: '',
    modifierUserId: 0,
    modifierUserName: '',
    name: '',
    workspaceId: '',
};
//# sourceMappingURL=templates.js.map